<template>
  <div
    v-tooltip="
      canCreateAlert
        ? null
        : `Pour créer une alerte, vous devez d'abord en supprimer une (3 alertes maximum autorisées)`
    "
  >
    <DsfrButton
      icon="RiNotification3Fill"
      :type="type"
      @click="onClick"
      :size="size"
      :disabled="!canCreateAlert"
    >
      Créer une alerte
    </DsfrButton>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    size: {
      type: String,
      default: 'md',
      validator: (s) => ['xs', 'sm', 'md', 'lg'].includes(s),
    },
    type: {
      type: String,
      default: 'primary',
      validator: (s) =>
        ['primary', 'transparent', 'secondary', 'tertiary', 'tertiary-no-outline'].includes(s),
    },
  },
  computed: {
    canCreateAlert() {
      return this.$stores.userAlert.alerts.length < 3
    },
  },
  methods: {
    onClick() {
      this.$stores.userAlert.resetOverlay()
      this.$stores.userAlert.showDisplayOverlay(null, 'form')
      this.$plausible.trackEvent('User Alert - Add new', {
        props: { isLogged: this.$stores.auth.isLogged },
      })
    },
  },
})
</script>
